export {};
//# sourceMappingURL=resize-observer.js.map